function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SuccessTemplate = require('./success.template');
var Success = /*#__PURE__*/function () {
  function Success(app, mod) {
    _classCallCheck(this, Success);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, true);
    this.acquisitionMessageShown = false;
  }
  return _createClass(Success, [{
    key: "render",
    value: function render() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.mod.attachStyleSheets();
      var amountLabel = opts.amountLabel || (opts.tx ? "".concat(this.app.wallet.convertNolanToSaito(this.amountFromIssuance(opts.tx)), " SAITO") : "".concat(this.app.wallet.convertNolanToSaito(this.mod.amount), " SAITO"));
      this.overlay.show(SuccessTemplate(this.app, this.mod, {
        amountLabel: amountLabel
      }));
      this.attachEvents();
      this.showAcquisitionSiteMessageOnce();
    }
  }, {
    key: "close",
    value: function close() {
      this.overlay.close();
    }
  }, {
    key: "amountFromIssuance",
    value: function amountFromIssuance(tx) {
      var total = 0n;
      var pk = this.mod.publicKey;
      if (!(tx !== null && tx !== void 0 && tx.to) || !pk) {
        return this.mod.amount;
      }
      var _iterator = _createForOfIteratorHelper(tx.to),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var slip = _step.value;
          if (slip.publicKey === pk) {
            try {
              total += BigInt(slip.amount || 0);
            } catch (err) {
              // ignore malformed slip amounts
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return total > 0n ? total : this.mod.amount;
    }
  }, {
    key: "showAcquisitionSiteMessageOnce",
    value: function showAcquisitionSiteMessageOnce() {
      if (this.acquisitionMessageShown) {
        return;
      }
      this.acquisitionMessageShown = true;
      siteMessage('Your SAITO is now in your wallet. Please continue.', 5000);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var btn = document.querySelector('.faucet-success .saito-button-primary');
      if (btn) {
        btn.onclick = function () {
          _this.mod.waiting_overlay.close();
          _this.close();
          _this.mod.auth_overlay.close();
          try {
            var _this$app$modules$ret;
            var purchase = (_this$app$modules$ret = _this.app.modules.returnModule('BuySaito')) === null || _this$app$modules$ret === void 0 ? void 0 : _this$app$modules$ret.purchase_overlay;
            if (purchase && typeof purchase.close === 'function') {
              purchase.close();
            }
          } catch (err) {
            console.error('FAUCET: failed to close BuySaito overlay', err);
          }
        };
      }
    }
  }]);
}();
module.exports = Success;